import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../../assets/css/article/ArticleCarte.css";
import { imageArticleUrl } from "../../utils/modules";
import { truncateText } from "../../utils/formatTexte";
import { formatPrice } from "../../utils/formatPrice";
import { getInitial } from "../../utils/getInitialName";
import LazyImage from "../../components/article/LazyImage.jsx";
import { hasUserFavorited, getFavorisCount } from "../../utils/favoris";
import useArticle from "../../hooks/useArticle";
import { useNavigate } from "react-router-dom";
import noImage from "../../assets/images/articles/no-photo.png";
import useNotification from "../../hooks/useNotification";
import useNotify from "../../hooks/useNotify";
import LoaderArticle from "../../components/loader/article/LoaderArticle.jsx";

const ArticleCarte = ({ article, onToggleFavori, setLoadingVersDetails }) => {
  const navigate = useNavigate();
  const { updateArticleCounter } = useArticle();
  const { createNotification } = useNotification();

  const currentUserId =
    JSON.parse(localStorage.getItem("user"))?._id ||
    JSON.parse(sessionStorage.getItem("user"))?._id;

  const [favorisCount, setFavoriCount] = useState(
    getFavorisCount(article.nbFavoris, article._id) || 0,
  );
  const [isFavorited, setIsFavorite] = useState(
    hasUserFavorited(article.nbFavoris, currentUserId, article._id) || false,
  );

  const [isContentProfil, setIsContentProfil] = useState(false);

  const isBoosted = article.boostActif === 1;
  const defaultImage = `${imageArticleUrl}/files/article/default-image.png`;

  const nomUtilisateur = article?.pseudo
    ? article?.pseudo
    : article.idUtilisateur?.nom
      ? article.idUtilisateur?.nom
      : "Anonyme";

  const { notifyArticleLiked } = useNotify();

  const isOwner =
    !!currentUserId && article?.idUtilisateur?._id === currentUserId;

  useEffect(() => {
    if (currentUserId) {
      const listArticleInteracted = JSON.parse(
        localStorage.getItem("articles"),
      );
      if (listArticleInteracted && listArticleInteracted.length > 0) {
        listArticleInteracted.map(async (articleStorage) => {
          if (articleStorage._id == article._id) {
            setIsFavorite(true);
            await updateArticleCounter(
              articleStorage._id,
              articleStorage.params,
            )
              .then((res) => { })
              .catch((err) => console.log(err));

            const newList = listArticleInteracted.filter(
              (el) => el._id != article._id && el.params == "nbFavoris",
            );
            localStorage.setItem("articles", JSON.stringify(newList));
          }
        });
      }
    }
  }, []);

  useEffect(() => {
    if (article.idUtilisateur?.photo) {
      if (article.idUtilisateur.photo == "/default.png") {
        setIsContentProfil(false);
      } else if (/^https?:\/\//i.test(article.idUtilisateur.photo)) {
        setIsContentProfil(true);
      } else {
        setIsContentProfil(true);
      }
    }
  }, [article]);

  const actionOnClick = async (aritleId, params) => {
    const listArticleInteracted = JSON.parse(localStorage.getItem("articles"));
    if (currentUserId) {
      await updateArticleCounter(aritleId, params)
        .then((res) => { })
        .catch((err) => console.log(err));
    } else {
      if (listArticleInteracted && listArticleInteracted.length > 0) {
        const isInclude = listArticleInteracted.filter(
          (el) => el._id == aritleId && el.params == "nbFavoris",
        );

        if (isInclude && isInclude.length == 0) {
          const newList = [
            ...listArticleInteracted,
            { _id: aritleId, params: params },
          ];
          localStorage.setItem("articles", JSON.stringify(newList));
        } else {
          const newList = listArticleInteracted.filter(
            (el) => el._id != aritleId && el.params == "nbFavoris",
          );
          localStorage.setItem("articles", JSON.stringify(newList));
        }
      } else {
        localStorage.setItem(
          "articles",
          JSON.stringify([{ _id: aritleId, params: params }]),
        );
      }
    }
  };

  const renderVendeurPhotoSrc = (photo) => {
    const image = String(photo || "").trim();
    if (/^https?:\/\//i.test(photo)) return photo;
    return `${process.env.REACT_APP_ARTICLE_IMAGE}/${image}`;
  };

  const shareArticle = () => {
    updateArticleCounter(article._id, "nbPartageFacebook")
      .then((res) => { })
      .catch((err) => {
        console.log(err);
      });

    const url = `https://web.facebook.com/sharer.php?u=https://api.deal.mg/api/v1/article/share/socialMedia/${article._id}&_rdc=1&_rdr#`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  useEffect(() => {
    const userId =
      JSON.parse(localStorage.getItem("user"))?._id ||
      JSON.parse(sessionStorage.getItem("user"))?._id;

    setFavoriCount(getFavorisCount(article.nbFavoris, article._id) || 0);
    setIsFavorite(
      hasUserFavorited(article.nbFavoris, userId, article._id) || false,
    );
  }, [article]);

  const hasPrice = Number(article?.prix) > 0;

  const etatArticleLabel =
  hasPrice && Number(article?.etat) === 1
    ? "Neuf"
    : hasPrice && Number(article?.etat) === 2
      ? "Occasion"
      : "";

  return (
    <>
      <div
        className="article-carte-card-content"
        onClick={async (e) => {
          if (e.button !== 0) return;
          e.preventDefault();
          
          if (!isOwner) {
            await actionOnClick(article._id, "nbVue");
          }
          setLoadingVersDetails(true);
          window.scrollTo({ top: 0, behavior: "smooth" });
          setTimeout(() => {
            navigate(`/article/details/${article._id}`);
          }, 2000);
        }}
        style={{ textDecoration: "none", cursor: "pointer" }}
      >
        <div className="article-carte-header">
          {isContentProfil ? (
            <img
              src={`${renderVendeurPhotoSrc(article.idUtilisateur.photo)}?v=${Date.now()}`}
              alt={nomUtilisateur}
              className="article-carte-avatar"
              onError={(e) => {
                e.currentTarget.onerror = null;
                setIsContentProfil(false);
              }}
            />
          ) : (
            <div className="article-carte-avatar">
              {getInitial(nomUtilisateur)}
            </div>
          )}
          <div className="article-carte-user-name">
            {truncateText(nomUtilisateur ? nomUtilisateur : "Anonyme", 16)}
          </div>
        </div>

        <div className="article-carte-card-body">
          <LazyImage
            src={
              article.photos?.[0]
                ? `${imageArticleUrl}/${article.photos[0]}?v=${Date.now()}`
                : noImage
            }
            defaultImage={defaultImage}
            alt={article.titre}
            className="article-image-v3"
          />

          <div
            className="article-carte-like-badge"
            onClick={async (e) => {
              e.preventDefault();
              e.stopPropagation();

              const userId =
                JSON.parse(localStorage.getItem("user"))?._id ||
                JSON.parse(sessionStorage.getItem("user"))?._id;

              const wasFavorited = isFavorited;

              if (isFavorited) setFavoriCount(favorisCount - 1);
              else setFavoriCount(favorisCount + 1);

              setIsFavorite(!isFavorited);

              await actionOnClick(article._id, "nbFavoris");

              if (userId && !wasFavorited) {
                await notifyArticleLiked(article);
              }
            }}
          >
            <i
              className="bi bi-heart-fill"
              style={{
                color: isFavorited
                  ? "var(--couleur-secondaire)"
                  : "var(--couleur-dark)",
              }}
            ></i>
            <span style={{ marginLeft: "1px" }}>{favorisCount}</span>
          </div>

          {isBoosted && <div className="content_text_boost">A la une</div>}
        </div>

        <div className="article-carte-footer">
          <span className="article-carte-title" itemProp="name">
            {truncateText(article.titre, 23)}{" "}
          </span>
          {article?.prix && article.prix > 0 ? (
            <span className="article-carte-price">
              {formatPrice(article.prix)} MGA
            </span>
          ) : (
            "\u00A0"
          )}

          <div className="article-carte-footer-bottom">
            <div className="article-carte-location-wrap">
              <span className="article-carte-location text-uppercase">
                {truncateText(article.ville, 20)}{" "}
              </span>

            {/* {etatArticleLabel && (
                <span className="article-carte-etat">
                  {etatArticleLabel}
                </span>
              )}*/}

              {/* <div>
              <i
                class="bi bi-facebook"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  shareArticle();
                }}
                style={{ color: "#1877F2", fontSize: "1.2em" }}
                title="Partager sur Facebook"
              ></i>

              <i
                className="bi bi-chat-dots-fill"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  navigate(`/message/${article._id}`);
                }}
                style={{ color: "var(--couleur-secondaire)", fontSize: "1.2em", marginLeft: "10px" }}
                title="Envoyer un message au vendeur"
              />
            </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ArticleCarte;
